﻿(function () {
  if (window.djCollectionLoadMoreReady) return;
  window.djCollectionLoadMoreReady = true;

  var selectors = {
    trigger: '[data-dj-load-more]',
    grid: '#ProductGridContainer #product-grid',
    item: '#ProductGridContainer #product-grid > li',
    wrapper: '.dj-collection-show-more'
  };

  function getNextUrl(trigger) {
    var explicitUrl = trigger.dataset.nextUrl || trigger.getAttribute('data-next-url') || trigger.getAttribute('href');
    if (explicitUrl) return explicitUrl;
    var nextPage = trigger.dataset.nextPage || trigger.getAttribute('data-next-page');
    if (!nextPage) return '';
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('page', nextPage);
    return url.pathname + url.search + url.hash;
  }

  function setLoading(trigger, loading) {
    trigger.classList.toggle('is-loading', loading);
    trigger.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      trigger.dataset.originalText = trigger.textContent.trim();
      trigger.textContent = trigger.dataset.loadingText || trigger.textContent.trim();
    } else if (trigger.dataset.originalText) {
      trigger.textContent = trigger.dataset.originalText;
    }
  }

  function rehydrateShopifyUI() {
    document.dispatchEvent(new CustomEvent('dj:collection-load-more:complete'));
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
    if (window.SPR && typeof window.SPR.registerCallbacks === 'function') {
      window.SPR.registerCallbacks();
      window.SPR.initRatingHandler();
      window.SPR.initDomEls();
      window.SPR.loadProducts();
    }
  }

  async function appendNextPage(trigger) {
    var currentGrid = document.querySelector(selectors.grid);
    if (!currentGrid || trigger.dataset.loading === 'true') return;

    var nextUrl = getNextUrl(trigger);
    if (!nextUrl) return;

    trigger.dataset.loading = 'true';
    setLoading(trigger, true);

    try {
      var response = await fetch(nextUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Load more request failed: ' + response.status);

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var incomingItems = Array.prototype.slice.call(doc.querySelectorAll(selectors.item));
      var currentWrapper = trigger.closest(selectors.wrapper);
      var incomingWrapper = doc.querySelector(selectors.wrapper);

      if (!incomingItems.length || !currentWrapper) {
        return;
      }

      incomingItems.forEach(function (item) {
        currentGrid.appendChild(document.importNode(item, true));
      });

      if (incomingWrapper) {
        currentWrapper.replaceWith(document.importNode(incomingWrapper, true));
      } else {
        currentWrapper.remove();
      }

      rehydrateShopifyUI();
    } catch (error) {
      console.warn('[DJFlowers] Load more failed without URL navigation:', error);
    } finally {
      trigger.dataset.loading = 'false';
      setLoading(trigger, false);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(selectors.trigger);
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      appendNextPage(trigger);
    },
    true
  );
})();

